<div class="call-for-tender-detail-container">
  <div class="header-content">
    <app-breadcrumbs [items]="breadcrumbItems"></app-breadcrumbs>
  </div>

  <div class="form-header-item" *ngIf="currentCallForTender">
    <h1>{{ detailTitle }}</h1>
    <div class="div-btns-top">
      <action-bar [showSave]="true" (onSave)="onSave()"></action-bar>
    </div>
  </div>

  <div class="call-for-tender-info" *ngIf="currentCallForTender">
    <div class="info-card">
      <div class="info-card-icon">
        <mat-icon>calendar_today</mat-icon>
      </div>
      <div class="info-card-content">
        <span class="info-card-label">{{ 'cft_creation_date' | translate }}</span>
        <span class="info-card-value">{{ formatDate(currentCallForTender.createDate) }}</span>
      </div>
    </div>
    <div class="info-card">
      <div class="info-card-icon info-card-icon--db">
        <mat-icon>storage</mat-icon>
      </div>
      <div class="info-card-content">
        <span class="info-card-label">{{ 'cft_db_version_label' | translate }}</span>
        <mat-form-field class="info-card-select">
          <mat-select [value]="selectedVersionId" (selectionChange)="onVersionChange($event.value)" [disabled]="true">
            <mat-option *ngFor="let version of dbVersions" [value]="version.versionId">
              {{ version.versionName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="title" *ngIf="currentCallForTender">
    <div class="title-left">
      <h3>{{ 'cft_add_projects_title' | translate }}</h3>
    </div>
  </div>

  <div class="solution-base-block" *ngIf="currentCallForTender">
    <div class="solution-base-content">
      <p class="solution-base-text" [innerHTML]="'cft_add_projects_description' | translate"></p>
      <div class="solution-base-buttons">
        <button class="solution-base-button" (click)="onCreateProject()">
          <mat-icon>add</mat-icon>
          <span>{{ 'cft_btn_create_project' | translate }}</span>
        </button>
        <button class="solution-base-button" (click)="onSelectProject()">
          <mat-icon>folder_open</mat-icon>
          <span>{{ 'cft_btn_select_project' | translate }}</span>
        </button>
        <button class="solution-base-button" (click)="onImportProject()">
          <mat-icon>upload</mat-icon>
          <span>{{ 'cft_btn_import_project' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="title" *ngIf="currentCallForTender">
    <div class="title-left">
      <h3>{{ 'cft_solutions_list_title' | translate }}</h3>
    </div>
  </div>

  <div class="solution-table-wrapper" *ngIf="currentCallForTender">
    <app-table
      [columns]="tableColumns"
      [rows]="displayedRows"
      [showDeleteAction]="true"
      [customCellTemplates]="{ solutionName: solutionTemplate, projectName: projectNameTemplate }"
      [draggableRows]="true"
      [dragPreviewLabelGetter]="getRowDragPreviewLabel"
      (rowsReordered)="onRowsReordered($event)"
      (rowDelete)="onRowDelete($event)">
    </app-table>

    <ng-template #solutionTemplate let-row>
      <mat-form-field appearance="outline" class="solution-select-field">
        <mat-select [value]="row.selectedSolutionId" (selectionChange)="onSolutionChange(row.rowId, $event.value)">
          <mat-option *ngFor="let solution of getSolutionsForRow(row)" [value]="solution.id">
            {{ solution.displayName }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-template>

    <ng-template #projectNameTemplate let-row>
      <a [href]="'#/' + SiteMapUrl.MenuProject + '/' + row.projectId" target="_blank">{{ row.projectName }}</a>
    </ng-template>

    <div class="show-more-row" *ngIf="hasMoreRows" (click)="showMore()">{{ 'cft_show_more' | translate }}</div>
  </div>

  <div class="title" *ngIf="scenario && hasSolutions">
    <div class="title-left">
      <h3>{{ 'cft_select_indicators_title' | translate }}</h3>
    </div>
  </div>

  <div class="indicators-section" *ngIf="scenario && hasSolutions">
    <div class="indicators-grid">
      <div class="indicator-item" *ngFor="let item of scenario?.indicatorSelected">
        <mat-checkbox [checked]="item?.isChecked || false" (change)="onIndicatorChange(item, $event)">
          {{ getIndicatorLabel(item) }}
        </mat-checkbox>
      </div>
    </div>
  </div>

  <div class="synthesis-button-container" *ngIf="scenario && hasSolutions && (!syntheseRequested || hasModifications)">
    <button mat-raised-button class="synthesis-btn" (click)="showSynthese()">
      <mat-icon>assessment</mat-icon>
      <span>{{ (syntheseRequested ? 'cft_btn_refresh_synthesis' : 'cft_btn_show_synthesis') | translate }}</span>
    </button>
  </div>

  <div *ngIf="scenario && hasSolutions && syntheseRequested" class="synthese-container">
    <app-synthese [scenario]="scenario!" [projectId]="callForTenderId" [callForTenderId]="callForTenderId" [refreshKey]="scenarioRefreshKey" (loadError)="onSyntheseLoadError()"></app-synthese>
  </div>
</div>
